/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../common/Tooltip';

const propTypes = {
    settingsData: PropTypes.object.isRequired,
    onSettingChange: PropTypes.func.isRequired,
};

class PricingSettings extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isError: false,
        };
    }

    render() {
        const { settingsData, onSettingChange } = this.props;
        const badFeedbackOptions = [];
        for (let i = 1; i <= 10; i += 1) {
            badFeedbackOptions.push({ value: i, label: i.toString() });
        }
        return (
            <div className="system-settings-section">
                <div className="system-settings-section__header">
                    <div className="system-settings-section__title">
                        Pricing Settings
                    </div>
                </div>
                <div className="system-settings-section__content">
                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>Default client pay per hour</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Default minimum client pay per hour">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={1}
                                        className="duration"
                                        defaultValue={
                                            settingsData.DEFAULT_CLIENT_PAY_PER_HOUR
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                DEFAULT_CLIENT_PAY_PER_HOUR:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Cancelled booking charges</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Setting for client cancellation charges">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <textarea
                                        type="text"
                                        className={`settings-long-textfield ${this.state.isError ? 'error-border' : ''}`}
                                        rows={5}
                                        defaultValue={JSON.stringify(
                                            settingsData.CANCELLED_BOOKING_CHARGES,
                                        )}
                                        onBlur={event => {
                                            try {
                                                const coeff = JSON.parse(
                                                    JSON.stringify(
                                                        event.target.value,
                                                    ),
                                                );
                                                onSettingChange({
                                                    CANCELLED_BOOKING_CHARGES:
                                                        JSON.parse(coeff),
                                                });
                                                this.setState({ isError: false });
                                            } catch (error) {
                                                console.log(error);
                                                this.props.notification.error(
                                                    'Error', 'This is not a valid JSON.'
                                                );
                                                this.setState({ isError: true });
                                            }
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

PricingSettings.propTypes = propTypes;

export default PricingSettings;
